import React, { useState } from 'react';
import get from 'lodash/get';
import { useAsyncCallback } from 'react-async-hook';
import ReactLoading from 'react-loading';
import { FormGroup, ControlLabel } from 'react-bootstrap/lib';
import WidgetService from '../../../services/WidgetService';

function ImageUpload({
  label,
  name,
  formData,
  onChange,
}: {
  label: string;
  name: string;
  formData: object;
  onChange: ({ target }: { target: object }) => {};
}) {
  const [error, setError] = useState('');
  const value = get(formData, name);
  const uploadImage = useAsyncCallback(WidgetService.uploadImage);
  return (
    <FormGroup>
      <ControlLabel>{label}</ControlLabel>
      {uploadImage.loading ? (
        <ReactLoading type="bubbles" width="50px" color="black" />
      ) : (
        <div>
          <label>
            {value && (
              <span className="text-success  pr-5">
                <i className="glyphicon glyphicon-ok pr-5" /> File uploaded
              </span>
            )}
            {value ? (
              <button
                type="button"
                className="btn btn-default"
                onClick={(e) => {
                  e.preventDefault();
                  onChange({ target: { name, value: null } });
                }}
              >
                Remove
              </button>
            ) : (
              <>
                <span className="btn btn-default">Choose file</span>
                <input
                  type="file"
                  accept="image/*"
                  name={name}
                  style={{ display: 'none' }}
                  onChange={(e) => {
                    setError('');
                    const file = e.target?.files?.[0];
                    if (file) {
                      const data = new FormData();
                      data.append('image', file);
                      uploadImage
                        .execute(data)
                        .then((result: { Location: string }) => {
                          onChange({
                            target: { name, value: result.Location },
                          });
                        })
                        .catch((err) => {
                          setError(err?.message || 'Unknown error happened');
                        });
                    }
                    e.target.value = '';
                  }}
                />
              </>
            )}
            {error && <div className="error">{error}</div>}
          </label>
        </div>
      )}
    </FormGroup>
  );
}

export default ImageUpload;
